export const NAMES_FIELDS = {
  _ID: '_id',
  REF: '_ref',
}
